export function sbmBannerSlideshow() {
    'use strict';
    $ = jQuery;
    const bannerSlideShow = $('.sbm-banner-slideshow .slideshow_items');
    if (bannerSlideShow.length > 0) {
        const bsItem = bannerSlideShow.find('.slideshow_item');
        if (bsItem.length > 1) {
            bannerSlideShow.not('.slick-initialized').slick({
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                rows: 0,
                arrows: false,
                dots: true
            });
        }
    }
}
